import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { FontSizes, FontWeights } from '../../../../types/common/types';

export const templateIntegrityMonitorRulesApp = document.createElement('template');

templateIntegrityMonitorRulesApp.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper">
    <div class="loading-container">
      <gz-progress-spinner size="large"></gz-progress-spinner>
    </div>

    <gz-tab-group id="integrity-monitor-rules-tab-group">
      <gz-push-body-layout class="integrity-monitor-push-body">
        <div slot="push-body-sidenav-title">
          <gz-title id="smartviews-title" fontWeight="600" fontSize="11"></gz-title>
        </div>

        <div slot="push-body-sidenav">
          <gz-integrity-monitor-rules-smart-views></gz-integrity-monitor-rules-smart-views>
        </div>

        <div slot="push-body-content">
          <div class="wrapper">
            <header class='page__header'>
               <gz-title id="title" fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.TITLE}"></gz-title>
            </header>
            <div class="company-selector-action">
              <gz-company-selector id="company-selector"></gz-company-selector>
            </div>
            <gz-integrity-monitor-rules-grid></gz-integrity-monitor-rules-grid>
          </div>
        </div>
      </gz-push-body-layout>
    </gz-tab-group>
  </div>

  <div>
    <gz-integrity-monitor-add-custom-rule class="integrity-monitor-form"></gz-integrity-monitor-add-custom-rule>
  </div>

  <div>
    <gz-integrity-monitor-rule-set-form class="integrity-monitor-form"></gz-integrity-monitor-rule-set-form>
  </div>

  <div>
    <gz-integrity-monitor-assign-rules-form class="integrity-monitor-form"></gz-integrity-monitor-assign-rules-form>
  </div>

  <div>
    <gz-integrity-monitor-default-rule-configuration class="integrity-monitor-form"></gz-integrity-monitor-default-rule-configuration>
  </div>
`;
